import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	setBillingType,
	setPlan,
} from '../../../store/reducers/subscriptionSlice/subscriptionSlice';

const PricingCard = ({ plan, billing, onOpenFreeModal }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const selectedBilling = plan?.billing?.find((item) => item.period === billing);

	const buttonText =
		plan?.key === 'professional'
			? 'Go Professional'
			: plan?.key === 'enterprise'
				? 'Go Enterprise'
				: 'Get Started';

	const handleSelectPlan = async () => {
		try {
			if (plan?.key?.includes('free')) {
				onOpenFreeModal(plan);
				return;
			} else {
				const monthlyPlan = plan?.billing?.find((item) => item?.period === 'monthly');
				const yearlyPlan = plan?.billing?.find((item) => item?.period === 'yearly');

				const payload = {
					id: plan?._id,
					key: plan?.key,
					title: plan?.name,
					description: plan?.meta?.description,
					monthly_price: monthlyPlan?.amount_in_rupees || 0,
					yearly_price: yearlyPlan?.amount_in_rupees || 0,
					currency: selectedBilling?.currency,
					billingPeriod: billing,
					razorpay_plan_id: selectedBilling?.razorpay_plan_id,
					isRecurring: true,
				};

				dispatch(setPlan(payload));
				dispatch(setBillingType(billing));
				navigate('/checkout');
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="pricing-card">
			<h5 className="title">{plan?.name}</h5>

			<p className="desc">{plan?.meta?.description}</p>

			<div className="price">
				{plan?.custom ? (
					<p className="contact">Contact Us</p>
				) : (
					<div className="price-main">
						₹{selectedBilling?.amount_in_rupees}
						<span className="duration">/{billing === 'monthly' ? 'month' : 'year'}</span>
					</div>
				)}
			</div>

			<ul className="features">
				{plan?.display_features?.map((item, i) => (
					<li key={i}>
						<IoMdCheckmarkCircleOutline className="icon" />

						<span>{item}</span>
					</li>
				))}
			</ul>

			<div className="btn-group-custom">
				<button
					onClick={handleSelectPlan}
					className="btn btn-primary w-100"
				>
					{buttonText}
				</button>

				<button className="btn btn-primary w-100">Learn More</button>
			</div>
		</div>
	);
};

export default PricingCard;
